import * as Sentry from '@sentry/react';

const appEnv = import.meta.env.VITE_APP_ENV;
const isProduction = appEnv === 'production';
const isDevelopment = appEnv === 'development';

Sentry.init({
  environment: appEnv,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: false,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
    Sentry.feedbackIntegration({
      colorScheme: 'system',
    }),
  ],
  enableLogs: true,
  // Tracing — 100% in dev for debugging, 10% in production to control costs
  tracesSampleRate: isDevelopment ? 1 : isProduction ? 0.1 : 0,
  tracePropagationTargets: import.meta.env.VITE_API_URL
    ? [import.meta.env.VITE_API_URL]
    : [],
  // Replay — 10% of sessions, 100% of sessions with an error
  replaysSessionSampleRate: appEnv ? 0.1 : 0,
  replaysOnErrorSampleRate: appEnv ? 1.0 : 0,
});
